import createSaga from "./create/create.saga";
import editSaga from "./edit/edit.saga";

export default [...createSaga, ...editSaga];
